import { Link } from "react-router-dom";
import { ArrowRight, FileText, Phone, Check } from "lucide-react";
import Reveal from "@/components/reveal";

const Candidates = () => (
  <main data-testid="candidates-page">
    {/* HERO (dark) */}
    <section className="relative bg-[#0B132B] overflow-hidden">
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 orange-glow" />
      <div className="container-nb relative pt-36 pb-20 md:pt-44 md:pb-28">
        <Reveal>
          <p className="eyebrow mb-6">For Candidates</p>
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.12] text-[#F8FAFC] max-w-3xl">
            Looking for your next opportunity?
          </h1>
          <p className="mt-7 text-base md:text-lg text-[#94A3B8] leading-relaxed max-w-xl">
            NicheBytes works with specialist technology professionals — connecting the right people
            with the right opportunities, personally.
          </p>
        </Reveal>
      </div>
    </section>

    {/* TWO OPTIONS (light) */}
    <section className="bg-[#FAF9F5]">
      <div className="container-nb py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl">
          <Reveal>
            <div className="card-light p-8 md:p-10 h-full flex flex-col transition-transform duration-300 hover:-translate-y-1" data-testid="candidates-option-share-cv">
              <div className="w-11 h-11 rounded-xl bg-[#FF5E1A]/10 border border-[#FF5E1A]/20 flex items-center justify-center mb-6">
                <FileText size={20} className="text-[#FF5E1A]" />
              </div>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-[#0F172A] mb-3">Share Your CV</h2>
              <p className="text-sm md:text-base text-[#475569] leading-relaxed mb-8 flex-1">
                Submit your CV to be considered for relevant opportunities.
              </p>
              <Link to="/contact?interest=cv" data-testid="candidates-cta-share-cv" className="btn-primary w-fit">
                Share Your CV <ArrowRight size={15} />
              </Link>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="card-light p-8 md:p-10 h-full flex flex-col transition-transform duration-300 hover:-translate-y-1" data-testid="candidates-option-lets-connect">
              <div className="w-11 h-11 rounded-xl bg-[#FF5E1A]/10 border border-[#FF5E1A]/20 flex items-center justify-center mb-6">
                <Phone size={20} className="text-[#FF5E1A]" />
              </div>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-[#0F172A] mb-3">Let's Connect</h2>
              <p className="text-sm md:text-base text-[#475569] leading-relaxed mb-8 flex-1">
                Want to discuss your career or future opportunities?
              </p>
              <Link to="/contact?interest=connect" data-testid="candidates-cta-connect" className="btn-outline-light w-fit">
                Let's Talk <ArrowRight size={15} />
              </Link>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="mt-12 text-sm text-[#475569] max-w-xl leading-relaxed">
            Every conversation is personal and confidential. No CV broadcasting, no pressure — just an
            honest discussion about where you want to go next.
          </p>
        </Reveal>
      </div>
    </section>
    {/* WHAT YOU CAN EXPECT (white) */}
    <section className="bg-white border-t border-[#E6E2D8]">
      <div className="container-nb py-20 md:py-28">
        <Reveal className="max-w-2xl">
          <p className="eyebrow mb-5">What You Can Expect</p>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-[#0F172A]">
            What you can expect.
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-12 max-w-4xl">
          {[
            { title: "Relevant Opportunities", desc: "We focus on opportunities that genuinely match your experience and interests." },
            { title: "Honest Conversations", desc: "Clear information about the opportunity, company and process." },
            { title: "Respect For Your Time", desc: "No unnecessary processes or irrelevant outreach." },
            { title: "Long-Term Connection", desc: "Even if the timing isn't right today, we aim to build relationships for the future." },
          ].map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06}>
              <div className="flex gap-4" data-testid={`expect-${i + 1}`}>
                <span className="mt-1 w-6 h-6 rounded-full bg-[#FF5E1A]/10 border border-[#FF5E1A]/25 flex items-center justify-center shrink-0">
                  <Check size={13} className="text-[#FF5E1A]" />
                </span>
                <div>
                  <h3 className="font-display text-lg font-semibold text-[#0F172A] mb-2">{item.title}</h3>
                  <p className="text-sm md:text-base text-[#475569] leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </main>
);

export default Candidates;
